import { button as buttonStyles } from "@nextui-org/theme";
import { Link } from "@nextui-org/link";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col justify-center items-center min-h-[60vh] gap-6">
      <h2 className="text-4xl font-bold">404 - Page Not Found</h2>
      <p className="text-default-500 text-lg">
        The page you are looking for does not exist.
      </p>
      <Link
        className={buttonStyles({
          color: "primary",
          radius: "md",
          size: "lg",
          variant: "shadow",
        })}
        href="/"
      >
        Back to Home
      </Link>
    </div>
  );
}
